import React, { Component } from 'react';
import { formDataSchema } from '../../../../schema/add-role';
import { filter, formData, dissableFormData } from '../../../../schema/apppointment';
import Datepicker from '../../../../components/FormComponent/Date';
import Select2 from '../../../../components/FormComponent/select2';
import Inputlayer from '../../../../components/FormComponent/Input';
const $ = require('jquery');

class Add_Role extends Component {
    constructor(props) {
        super(props)
        this.state = {        
            formData: []
        }
    }

    render() {
        return (
            <div>
                <div className="card pt-5 pb-5 m-5">
                    <h1 className="text-center text-capitalize text-heading mb-0">Add New Role</h1>
                    <div className="row pt-4 pl-5 pr-5 justify-content-center">

                    {formDataSchema.feilds
                            .map((feild, key) => {

                                if (feild.element === 'input') {
                                    return (                                    
                                            <div
                                            className={`${feild.className
                                                ? feild.className
                                                : 'col'} my-2 ${feild.name}`}
                                            key={key}>
                                          <div className="clearfix">
                                          <p className="data-label w-100 mb-1">{feild.text}</p>
                                          </div>
                                            <Inputlayer
                                                {...this.props}
                                                {...this.state}
                                                feildData={feild}
                                                
                                            />                                        
                                        </div>                                           
                                    )
                                }
                            })
                        }
                    </div>
                    <div className="row pt-4 pl-5 pr-5 pb-5 align-items-end">
                        {formDataSchema.feilds
                            .map((feild, key) => {                                
                                if (feild.element === 'checkbox') {
                                    return (
                                        <div
                                            className={`${feild.className
                                                ? feild.className
                                                : 'col'} my-2 ${feild.name}`}
                                            key={key}>
                                        <input type="checkbox" id={feild.text} name={feild.text} value={feild.text} /> <label for={feild.text} className="data-label w-75">  {feild.text}</label>
                                        </div>

                                    )
                                }                              
                                if (feild.element === 'select2') {
                                    return (
                                        <React.Fragment key={key}>
                                            {(feild.name === 'patient_list' && feild.disable === false) &&
                                                <div className="col-6">
                                                    <p className="mb-0 text-black pl-0" style={{ fontSize: 13 + 'px', lineHeight: 2, backgroundColor: 'transparent' }}><span className="text-info" style={{ fontSize: 15 + 'px', lineHeight: 2 }}>Note:</span> Please Select Patient List</p>
                                                </div>}
                                            <div
                                                className={`${feild.className
                                                    ? feild.className
                                                    : 'col '} my-2 ${feild.name}`}
                                                key={key}>
                                                <p className="data-label w-100 mb-1 pt-2">{feild.text}</p>
                                                <Select2
                                                    Queuedata={formData}
                                                    selectdata={feild}
                                                    {...this.props}
                                                    {...this.state}
                                                /> {feild
                                                    .errors
                                                    .map((error, eKey) => {
                                                        return (
                                                            <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                        );
                                                    })}
                                            </div>
                                        </React.Fragment>
                                    )
                                }
                                if (feild.element === 'date') {
                                    return (
                                        <div
                                            className={`${feild.className
                                                ? feild.className
                                                : 'col '} my-2 ${feild.name}`}
                                            key={key}>
                                            <p className="data-label w-100 mb-1 pt-2">{feild.text}</p>
                                            <Datepicker
                                                // Queuedata={filtereData}
                                                selectdata={feild}
                                                {...this.props}
                                                {...this.state}
                                            // onselectChanges={this
                                            //     .onChange
                                            //     .bind(this)} 
                                            />
                                        </div>
                                    )

                                }
                            })}                      
                    </div>
                    <div className="row justify-content-center">
                        <button className="btn btn-success text-capitalize mr-3">Add Role</button>
                        <button className="btn btn-success btn-next text-capitalize">cancel</button>
                    </div>
                </div>
            </div>
        )

    }
}
export default Add_Role;